import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "reactive-width backdrop" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "locate-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "map-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "my-map",
    class: "map"
  }, [
    /*#__PURE__*/_createTextVNode(" Something went wrong :( "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Try reloading? ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" Click the Find Me button to get started. "),
    _hoisted_2,
    _createTextVNode(" Enter your address or zip code, or leave it blank to use your location. "),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        class: "clean-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address) = $event)),
        placeholder: "54321 Hollywood Boulevard"
      }, null, 512), [
        [_vModelText, _ctx.address]
      ]),
      (!_ctx.next)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button-indigo",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.findUser()))
          }, " Find Me! "))
        : _createCommentVNode("", true),
      (_ctx.next)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button-orange",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getPopular()))
          }, " Next-> "))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5
  ]))
}